var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7409 8.79232C13.7409 11.7363 11.3516 14.1257 8.40755 14.1257C5.46355 14.1257 3.66622 11.1603 3.66622 11.1603M3.66622 11.1603H6.07689M3.66622 11.1603V13.827M3.07422 8.79232C3.07422 5.84832 5.44222 3.45898 8.40755 3.45898C11.9649 3.45898 13.7409 6.42432 13.7409 6.42432M13.7409 6.42432V3.75765M13.7409 6.42432H11.3729",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.419dfe6ba3fda89cdf336d4f6e6db6a8.svg";
export { ForwardRef as ReactComponent };